// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDdQvNvezwISPfnlwPkyAF2USPLtUTRjh4",
  authDomain: "tenvosai-55ef7.firebaseapp.com",
  projectId: "tenvosai-55ef7",
  storageBucket: "tenvosai-55ef7.firebasestorage.app",
  messagingSenderId: "161356931698",
  appId: "1:161356931698:web:ce0b57570804a8a82318eb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;